<template>
    <div class="container">
        <a-card>
            <template #title>
                <a-breadcrumb separator=">">
                    <a-breadcrumb-item>
                        <FileOutlined/>
                        <a href="/docs"><span>Documentos</span></a>
                    </a-breadcrumb-item>
                    <a-breadcrumb-item>
                        Histórico de Emissão
                    </a-breadcrumb-item>
                </a-breadcrumb>
            </template>
            <a-form-item label="Tipo de Certidão">
                <a-select v-model:value="docType" placeholder="Selecione" @change="changeType" style="width: 350px; margin-right: 5px" :options="optionsDocType"/>
                <a-input v-model:value="year" style="width: 350px" type="number" placeholder="Exercício (opcional)" @change="onYearChange" />
            </a-form-item>
            <a-table
                :columns="columns"
                :data-source="docsFiltered"
                :pagination="pagination"
                :loading="loading"
                :row-key="record => record.id"
                bordered
                @change="handleTableChange"
            >
                <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'acao'">
                        <a-button type="primary" danger shape="circle"
                                  @click="open(record, 'pdf')">
                            <template #icon>
                                <a-tooltip>
                                    <template #title>PDF</template>
                                    <FilePdfOutlined/>
                                </a-tooltip>
                            </template>
                        </a-button>
                        <a-button type="primary" shape="circle"
                                  @click="open(record, 'docx')">
                            <template #icon>
                                <a-tooltip>
                                    <template #title>DOCX</template>
                                    <FileWordOutlined/>
                                </a-tooltip>
                            </template>
                        </a-button>
                        <a-button type="primary" shape="circle" style="background-color: #2f7d2f"
                                  @click="openModal(record)">
                            <template #icon>
                                <a-tooltip>
                                    <template #title>Alterar</template>
                                    <UploadOutlined/>
                                </a-tooltip>
                            </template>
                        </a-button>

                    </template>

                </template>
            </a-table>
            <a-modal
                v-model:open="isModalOpen"
                @ok="handleOk"
                title="Alterar Documento"
            >
                <a-upload name="logo" :before-upload="handleBeforeUpload"
                          :max-count="1" :file-list="data.files"
                          accept=".pdf,.docx">
                    <a-button>
                        <template #icon>
                            <UploadOutlined/>
                        </template>
                        Alterar documento
                    </a-button>
                </a-upload>
            </a-modal>
        </a-card>
    </div>
</template>
<script setup>
import {ref, computed, onMounted} from "vue";
import {FilePdfOutlined, FileWordOutlined, UploadOutlined} from '@ant-design/icons-vue';

import "codemirror/mode/sql/sql.js";
import "codemirror/theme/neat.css";
import axios from "axios";
import { message } from "ant-design-vue";

const extractDocName = (path) => {
    if (!path) return '';
    const normalized = path.replace(/^https?:\/\/[^/]+/, '');
    const fileName = normalized.split('/').pop() || '';
    return fileName.replace(/\.pdf$/i, '');
}

const docType = ref()
const optionsDocType = ref()
const loading = ref(false)
const total = ref(0)
const currentPage = ref(1)
const pageSize = ref(20)

const pagination = computed(() => ({
    total: total.value,
    current: currentPage.value,
    pageSize: pageSize.value,
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '50', '100'],
    showTotal: (t, range) => `${range[0]}-${range[1]} de ${t} registros`,
}))

const open = (record, extension) => {
    let path = extension === 'pdf' ? record.path : record.path.replace('pdf', 'docx');
    window.open(path)
}
const docSelected = ref()

const docsFiltered = ref([]);

const openModal = (record) => {
    isModalOpen.value = true;
    docSelected.value = record
    data.value.files = []
    data.value.doc_name = extractDocName(record.path)
    data.value.doc_path = record.path
}

async function loadHistory() {
    if (!docType.value) return
    loading.value = true
    try {
        const params = new URLSearchParams({ page: currentPage.value, per_page: pageSize.value })
        if (year.value != null && year.value !== '') params.set('year', year.value)
        const { data: res } = await window.axios.get(`/api/docs/history/${encodeURIComponent(docType.value)}?${params}`)
        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZone: 'America/Sao_Paulo',
            hour12: false,
        }
        docHistories.value = (res.data || []).map(doc => {
            const date = new Date(doc.created_at)
            const formatted = new Intl.DateTimeFormat('pt-BR', options).format(date)
            return { ...doc, user_name: `${doc.user?.name ?? ''} / ${doc.user?.email ?? ''}`, created_at: formatted }
        })
        docsFiltered.value = docHistories.value
        const meta = res.meta || {}
        total.value = meta.total ?? 0
    } finally {
        loading.value = false
    }
}

function onYearChange() {
    currentPage.value = 1
    loadHistory()
}

function handleTableChange(pag) {
    currentPage.value = pag.current
    pageSize.value = pag.pageSize
    loadHistory()
}

const data = ref({
    files: [],
    doc_name: "",
    doc_path: ""
})

const year = ref()

const ALLOWED_EXTENSIONS = ['pdf', 'docx', 'doc'];

const isModalOpen = ref(false);
const handleBeforeUpload = (file) => {
    const ext = (file.name || '').split('.').pop()?.toLowerCase();
    if (!ext || !ALLOWED_EXTENSIONS.includes(ext)) {
        message.warning('Envie apenas arquivo PDF ou DOCX.');
        return false;
    }
    data.value.files = [file];
    if (docSelected.value?.path) {
        data.value.doc_name = extractDocName(docSelected.value.path);
        data.value.doc_path = docSelected.value.path;
    }
    return false;
};

const handleOk = async () => {
    if (!data.value.files?.length) {
        message.warning('Selecione um arquivo para substituir o documento.')
        return
    }
    const file = data.value.files[0];
    const ext = (file.name || '').split('.').pop()?.toLowerCase();
    if (!ext || !ALLOWED_EXTENSIONS.includes(ext)) {
        message.warning('Envie apenas arquivo PDF ou DOCX.');
        return
    }
    const formData = new FormData();
    formData.append('doc_name', data.value.doc_name);
    formData.append('doc_path', data.value.doc_path);
    data.value.files.forEach((file) => {
        formData.append("files", file);
    });

    try {
        await window.axios.post(`/docs/alter-emited-doc`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        message.success('Documento alterado com sucesso.')
        docSelected.value = null
        data.value.doc_name = ""
        data.value.doc_path = ""
        data.value.files = []
        isModalOpen.value = false
        await loadHistory()
    } catch (err) {
        const msg = err.response?.data?.message ?? err.message ?? 'Erro ao alterar o documento.'
        message.error(msg)
        throw err
    }
}

const columns = ref([
    {
        title: 'Usuário',
        dataIndex: 'user_name',
        key: 'user_name',
        sorter: {
            compare: (a, b) => a.id - b.id,
        },
        width: 150,
    },
    {
        title: 'Processo',
        dataIndex: 'processo',
        key: 'processo',
        sorter: {
            compare: (a, b) => a.id - b.id,
        },
        width: 150,
    },
    {
        title: 'Matricula',
        dataIndex: 'matricula',
        key: 'matricula',
        sorter: {
            compare: (a, b) => a.id - b.id,
        },
        width: 150,
    },
    {
        title: 'Número da Certidão',
        dataIndex: 'numero_certidao',
        key: 'numero_certidao',
        sorter: {
            compare: (a, b) => a.id - b.id,
        },
        width: 150,
    },
    {
        title: 'Data/Hora Emissão',
        dataIndex: 'created_at',
        key: 'created_at',
        sorter: {
            compare: (a, b) => a.id - b.id,
        },
        width: 150,
    },
    {
        title: 'Ação',
        key: 'acao',
        width: 50,
    }
]);



const docHistories = ref([]);

const changeType = async () => {
    columns.value = columns.value.filter(item => item.dataIndex !== 'exercicio_venal');
    switch (docType.value) {
        case 'Valor Venal':
            columns.value.splice(columns.value.length - 1, 0, {
                title: 'Exercício Venal',
                dataIndex: 'exercicio_venal',
                key: 'exercicio_venal',
                sorter: {
                    compare: (a, b) => a.id - b.id,
                },
                width: 150,
            })
            break;

        case 'Valor Venal - Fração Ideal':
            columns.value.splice(columns.value.length - 1, 0, {
                title: 'Exercício Venal',
                dataIndex: 'exercicio_venal',
                key: 'exercicio_venal',
                sorter: {
                    compare: (a, b) => a.id - b.id,
                },
                width: 150,
            })
            break;
        case 'Localização':
            break;
    }

    const processoCol = columns.value.find(c => c.key === 'processo')
    if (processoCol) {
        processoCol.title = docType.value === 'Notificação' ? 'Descrição' : 'Processo'
        processoCol.dataIndex = docType.value === 'Notificação' ? 'descricao' : 'processo'
    }

    currentPage.value = 1
    await loadHistory()
}

onMounted(async () => {
    optionsDocType.value = (await window.axios.get('/api/docs/doc-types')).data.data.map(type => {
        return {
            value: type,
            label: type.toString().toUpperCase()
        }
    })
});
</script>
